import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#4e73df;',
        secondary: '#1E88E5',
        background: '#ffffff',
      },
    }
  }
}

export default new Vuetify(opts)
